import { features } from '@/mocks/downloadData';

export default function Features() {
  return (
    <section id="features" className="w-full px-4 md:px-8 py-14 md:py-20 scroll-mt-20">
      <div className="max-w-6xl mx-auto">
        <div className="grid lg:grid-cols-12 gap-10 items-start">
          <div className="lg:col-span-4 lg:sticky lg:top-24">
            <span className="inline-flex items-center gap-1.5 text-primary-600 text-xs font-medium tracking-wide">
              <i className="ri-sparkling-2-line"></i>
              FEATURES
            </span>
            <h2 className="mt-2 font-heading text-3xl md:text-4xl text-foreground-950 tracking-wide">
              为什么大家都选择手机版
            </h2>
            <p className="mt-3 text-foreground-600 text-sm md:text-base leading-relaxed">
              从播放体验到隐私保护，手机版针对日常使用场景做了大量优化，让浏览和观看更省心。
            </p>

            <div className="mt-6 rounded-lg overflow-hidden border border-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=close%20up%20of%20a%20modern%20smartphone%20held%20in%20hand%20on%20a%20clean%20warm%20beige%20studio%20background%2C%20screen%20glowing%20with%20abstract%20orange%20interface%20blocks%2C%20soft%20studio%20lighting%2C%20minimal%20editorial%20product%20photography&width=900&height=1100&seq=ppsp-feature-01&orientation=portrait"
                alt="手机端应用界面展示"
                className="w-full h-[280px] md:h-[340px] object-cover object-top"
              />
            </div>
          </div>

          <div className="lg:col-span-8 grid sm:grid-cols-2 gap-4">
            {features.map((f) => (
              <article
                key={f.title}
                className="rounded-lg border border-background-200 bg-background-50 p-5 hover:border-primary-300 transition-colors"
              >
                <div className="flex items-center justify-between">
                  <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 text-xl">
                    <i className={f.icon}></i>
                  </span>
                  <span className="px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs">{f.tag}</span>
                </div>
                <h3 className="mt-4 text-foreground-950 text-base font-medium">{f.title}</h3>
                <p className="mt-2 text-foreground-600 text-sm leading-relaxed">{f.desc}</p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}